import { FC, createContext, useContext, Dispatch, SetStateAction, useState } from "react";
import { WithChildren } from "../../../../../_metronic/helpers";
import { DLMApplication, DLMSiteApplication } from "../_models";

type DLMApplicationViewContextProps = {
    dlmAppData : DLMApplication | undefined
    siteIDs: Array<number>
    setSiteIDs : Dispatch<SetStateAction<Array<number>>>
    siteIndex: number
    setSiteIndex: Dispatch<SetStateAction<number>>
    selectedSite: DLMSiteApplication | null
    setSelectedSite: Dispatch<SetStateAction<DLMSiteApplication | null>>
}

const initialDLMApplicationView: DLMApplicationViewContextProps = {
    dlmAppData: undefined,
    siteIDs: [],
    setSiteIDs: () => {},
    siteIndex: -1,
    setSiteIndex: () => {},
    selectedSite: null,
    setSelectedSite: () => {},
}

const DLMApplicationViewContext = createContext<DLMApplicationViewContextProps>(initialDLMApplicationView);

type DLMApplicationViewProviderProps = {
    dlmAppData : DLMApplication | undefined
}

const DLMApplicationViewProvider: FC<WithChildren & DLMApplicationViewProviderProps> = ({ children, dlmAppData }) => {

    const [ siteIDs, setSiteIDs ] = useState<Array<number>>([]);

    const [ siteIndex, setSiteIndex ] = useState(-1);
    const [ selectedSite, setSelectedSite ] = useState<DLMSiteApplication| null>(null);
    
    if (! dlmAppData) {
        return <h4 className="text-dark">No information.</h4>        
    }

    return (        
        <DLMApplicationViewContext.Provider value={{dlmAppData, siteIDs, setSiteIDs, siteIndex, setSiteIndex, selectedSite, setSelectedSite}}>
            {children}            
        </DLMApplicationViewContext.Provider>        
    )

}
 
const useDLMApplicationView = () => useContext(DLMApplicationViewContext);

export {DLMApplicationViewProvider, useDLMApplicationView}  